import React, { FC } from "react";
import { Modal } from "@mui/material";

import { CloseIcon } from "application/assets";

import { MobilePopUpProps } from "./models";
import { ModalStyled, TopSection, CloseButton } from "./styles";

const MobilePopUp: FC<MobilePopUpProps> = ({
  open,
  onClose,
  title,
  children,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalStyled>
        <TopSection>
          <h1>{title}</h1>
          <CloseButton type="button" onClick={onClose}>
            <CloseIcon />
          </CloseButton>
        </TopSection>
        {children}
      </ModalStyled>
    </Modal>
  );
};

export default MobilePopUp;
